<template>
    <div v-if="user">
      <dashboard :cards="getDashboardCards"></dashboard>
    </div>
</template>

<script>
import dashboard from '@/components/tools/Dashboard';

import { mapState } from 'vuex';
export default {
    name: 'home',
    components: {
        dashboard
    },
    computed: {
        ...mapState({
            user: state => state.main.user,
        }),
        getDashboardCards () {
            let res = [];
            let dashboard = localStorage.getItem('dashboard');
            if (dashboard) {
                dashboard = JSON.parse(dashboard);
                for (let c of dashboard) {
                    if (!c) continue;
                    res.push(c);
                }
            }
            return res;
        },
    },
}
</script>

